"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapFetchText = exports.wrapFetch = exports.wrapFetchJson = exports.convertIdToUUID = exports.buildGenericRequest = exports.isSession = exports.Log = void 0;
const log_1 = require("log");
const Constants_1 = require("./Constants");
const Paths_1 = require("./Paths");
const Types_1 = require("./Types");
require("isomorphic-fetch");
exports.Log = (() => {
    if (log_1.Log !== undefined
        && log_1.Log.info !== undefined
        && log_1.Log.warn !== undefined
        && log_1.Log.error !== undefined
        && log_1.Log.debug !== undefined) {
        return log_1.Log;
    }
    return {
        info: console.log,
        warn: console.warn,
        debug: console.debug,
        error: console.error,
    };
})();
function isSession(arg) {
    return arg.baseUrl !== undefined;
}
exports.isSession = isSession;
function getHeaders(opts) {
    return __awaiter(this, void 0, void 0, function* () {
        const headers = {
            Accept: Paths_1.JSON_REQUEST,
            "User-Agent": Paths_1.USERAGENT,
            Authorization: `Bearer ${yield opts.session.accessToken()}`,
        };
        if (typeof opts.bodyType !== "undefined") {
            headers["Content-Type"] = opts.bodyType;
        }
        if (opts.headerOptions) {
            headers["User-Agent"] = opts.headerOptions.getCompiledUserAgent();
            headers[Types_1.DeakoRequestDevice.V1] = opts.headerOptions.getCompiledDeakoDeviceHeader();
        }
        return headers;
    });
}
function buildGenericRequest(session, request, options) {
    return __awaiter(this, void 0, void 0, function* () {
        let bodyType;
        if (request.method === "PUT" || request.method === "POST") {
            if (typeof request.body === "undefined") {
                throw new Error("Put and Post require a body");
            }
            else {
                bodyType = Paths_1.JSON_REQUEST;
            }
        }
        const headers = yield getHeaders({
            session,
            bodyType,
            headerOptions: options,
        });
        if (request.method === "PUT" || request.method === "POST") {
            return {
                method: request.method,
                headers,
                body: JSON.stringify(request.body),
            };
        }
        return {
            method: request.method,
            headers,
        };
    });
}
exports.buildGenericRequest = buildGenericRequest;
function executeConditionalPromise(tries, promise, handleErrors) {
    return __awaiter(this, void 0, void 0, function* () {
        return promise.then(handleErrors).catch((error) => {
            if (tries === 1) {
                throw error;
            }
            const nextTryCount = tries - 1;
            return executeConditionalPromise(nextTryCount, promise, handleErrors);
        });
    });
}
function executeConditionalFetch(retries, endpoint, request) {
    return __awaiter(this, void 0, void 0, function* () {
        return executeConditionalPromise(retries, fetch(endpoint, request), (item) => {
            if (item.status === Constants_1.HTTP_STATUSES.Unauthorized) {
                return item;
            }
            if (!item.ok) {
                throw Error(`Failed to make request to: ${endpoint} with ${JSON.stringify(request)}. Code:${item.status}`);
            }
            return item;
        });
    });
}
function handleRequest(endpoint, request) {
    return __awaiter(this, void 0, void 0, function* () {
        return executeConditionalFetch(3, endpoint, request);
    });
}
function convertIdToUUID(deviceId) {
    return deviceId.split("-").slice(1).join("-");
}
exports.convertIdToUUID = convertIdToUUID;
function wrapFetchJson(request, endpoint) {
    return __awaiter(this, void 0, void 0, function* () {
        const start = Date.now();
        const response = yield handleRequest(endpoint, request);
        exports.Log.info(`Done with request to ${endpoint} in ${Date.now() - start}ms`);
        if (response.ok) {
            const data = yield response.text();
            return data ? JSON.parse(data) : {};
        }
        else {
            throw response;
        }
    });
}
exports.wrapFetchJson = wrapFetchJson;
exports.wrapFetch = wrapFetchJson;
function wrapFetchText(endpoint) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield handleRequest(endpoint);
        return response.text();
    });
}
exports.wrapFetchText = wrapFetchText;
//# sourceMappingURL=Utils.js.map